<template>
    <div class="pageBox">
        <!-- color="#FF722B"  -->
        <van-loading v-if="loading" type="spinner" size="24px"
            style="position: fixed; top: 30%; left: 50%; transform: translate(-50%, -50%); z-index: 9999;">
            加载中...
        </van-loading>
        <!--  -->
        <!-- :overlay="false" -->
        <!-- <van-popup v-model="show" class="vanPop" :style="{ backgroundColor: 'transparent' }"
            :close-on-click-overlay="false" :closeable="false" > -->
        <div v-if="show">
            <div class="loginBackground">
                <span class="sign_title">连续签到 <span style="color:#FA5151">{{ totalSignInDays }}</span> 天可领取超级礼包
                </span>
                <div class="form-container" v-if="listData.length > 0" style="
                                position: absolute;
                                top: 26%;
                                left: -6%;
                                right: 0;
                                margin: 0 auto;
                                width:71vw;
                                height:36vh;
                                text-align: center;
                            ">
                    <div class="title">
                        <span class="sign">已连续签到 <span style="color:#FA5151">{{ continuousSignInDays }}</span>
                            天</span>
                        <span class="signRecord" @click="goRecord()">领取记录</span>
                    </div>
                    <div class="list">
                        <div class="itemList" v-for="item in listData" :class="{ 'gift-package': item.type === 3 }">
                            <div class="giftName">第{{ item.days }}天</div>
                            <div style="position: relative;">
                                <img v-if="item.type === 1" src="../assets/amountGroup.png" class="giftImg"
                                    :class="{ 'blurred': continuousSignInDays >= 1 && item.days <= continuousSignInDays }"></img>
                                <img v-if="item.type === 2" src="../assets/signIn/CreditScore.png" class="giftImg"
                                    :class="{ 'blurred': continuousSignInDays >= 1 && item.days <= continuousSignInDays }"
                                    style="width:40px;height:40px;">
                                <img v-if="item.type === 3" src="../assets/signIn/giftPacks.png" class="giftImg"
                                    :class="{ 'blurred': continuousSignInDays >= 1 && item.days <= continuousSignInDays }">
                                <img src="../assets/signIn/receiveImg.png" class="already"
                                    v-if="continuousSignInDays >= 1 && item.days <= continuousSignInDays">
                                <img v-if="item.type === 0" src="../assets/thankParticipating.png" class="giftImg"
                                    :class="{ 'blurred': continuousSignInDays >= 1 && item.days <= continuousSignInDays }">
                            </div>
                            <div class="pouponDetail">
                                {{ item.type === 2 ? item.activityProductDTOList[0].amount + '信誉分' : item.type === 1
                                    ? item.activityProductDTOList[0].amount / 100 + '元现金' : item.type === 3 ? '惊喜大礼包' :
                                        '无奖励'
                                }}
                            </div>
                        </div>
                    </div>
                    <!--  -->
                    <div class="buts" v-if="todaySignInDay === 0" @click="collect()">签到领取礼物</div>
                    <div class="buts" style="opacity: 0.3;" v-else>今日已签到</div>
                    <div @click="closePageCompletely()"
                        style="text-align:center;font-weight: 400;font-size: 14px;color: #999999;margin-top:3px;">以后再说
                    </div>
                </div>
                <div style="position: fixed;top:35%;left:0;right:0;text-align: center;" v-else>暂无数据</div>
            </div>
        </div>
        <!-- </van-popup> -->
        <!-- 签到成功弹框 -->
        <van-popup v-model="showContent" class="vanPop" :style="{ backgroundColor: 'transparent' }"
            :close-on-click-overlay="false" :closeable="false" :overlay="false">
            <div :class="obtain.length > 3 ? 'signSuccLength' : 'signSucc'" @click.stop>
                <div class="popupList" :style="popupStyles">
                    <div class="signTitle">签到成功，恭喜获得</div>
                    <div class="contentList">
                        <div class="centerContent" v-for="item in obtain" :key="item.id">
                            <img v-if="item.activityProductType === 70" src="../assets/amountGroup.png" class="popImg"
                                :style="popImgStyles">
                            <img v-if="item.activityProductType === 60 || item.activityProductType === 30"
                                :src="`${picUrl}/${item.activityProductImgJSON.detailImages}`" class="popImg"
                                :style="popImgStyles">
                            <img v-if="item.activityProductType === 40" src="../assets/thankParticipating.png"
                                class="popImg" :style="popImgStyles">
                            <img v-if="item.activityProductType === 90" src="../assets/signIn/CreditScore.png"
                                class="popImg" :style="popImgStyles">
                            <div style="margin-top:5px;font-size:16px;display: flex;align-items: center;">
                                <div v-if="item.activityProductType === 70 || item.activityProductType === 90">{{
                                    item.activityProductType === 70 ?
                                        item.activityProductAmount / 100 + '元' : item.activityProductAmount }}</div>
                                {{ item.activityProductName }}
                            </div>
                        </div>
                        <img v-if="obtain.length === 0" src="../assets/thankParticipating.png" class="popImg"
                            :style="popImgStyles" style="margin:10px auto;">
                    </div>
                    <!-- :style="{ 'margin-bottom': obtain.length > 3 ? '0' : '8px' }" -->
                    <span style="font-size:14px;color:#999999;margin-bottom:8px;">奖品需在领取记录兑换</span>
                    <div class="buts" style="margin:3px auto;" @click="submitCLose()">确定</div>
                </div>
            </div>
        </van-popup>
        <!-- end -->
        <!-- 签到礼包获得弹窗 -->
        <van-popup v-model="showGift" class="vanPop" :style="{ backgroundColor: 'transparent' }"
            :close-on-click-overlay="false" :closeable="false" :overlay="false">
            <div class="signSucc" @click.stop>
                <div class="popupList" style="height:236px;top:31%;">
                    <div class="signTitle" style="margin-bottom:15px;">分享后可领取惊喜大礼包</div>
                    <span @click="showGift = false" style="position:absolute;right:5px;top:0px;font-size:18px;">X</span>
                    <div class="centerContent" style="justify-content: center;margin:0 auto;">
                        <img src="../assets/signIn/giftPacks.png" style="height:65px;width:67px;"></img>
                    </div>
                    <span style="font-size:16px;margin-top:5px;">超级大礼包</span>
                    <div class="buts" style="margin:20px auto 0 auto;" @click="shareSubmit()">
                        <van-icon name="share" />
                        分享给朋友
                    </div>
                </div>
            </div>
        </van-popup>
        <!-- end -->

        <!-- end -->

    </div>
</template>

<script>
import { signInlist, queryTodaySignInDay, querySignIn } from '@/services/signIn'
import Cookies from "js-cookie";
import { Notify } from "vant";
import { Toast } from 'vant'
export default {
    data() {
        return {
            show: true,
            showContent: false,//签到成功;
            showGift: false,//礼包签到
            itemCount: 1,
            listData: [],
            listDataTotla: 0,
            todaySignInDay: 0,
            allData: [], // 存储所有原始数据
            totalSignInDays: 0,//签到的总数
            continuousSignInDays: 0,//连续签到天数
            obtain: [],
            picUrl: 'https://wowoto.oss-cn-shanghai.aliyuncs.com/pinboo',
            userId: "",
            loading: true,
        };
    },
    computed: {
        popupStyles() {
            const length = this.obtain.length;
            if (length > 3) {
                return {
                    height: 'auto',
                    maxHeight: '60vh',
                    minHeight: '40vh',
                    top: '60%',
                    transform: 'translateY(-50%)'
                };
            } else {
                return {
                    height: 'auto',
                    maxHeight: '45vh',
                    minHeight: '30vh',
                    top: '63%',
                    transform: 'translateY(-50%)'
                };
            }
        },
        popImgStyles() {
            const length = this.obtain.length;
            if (length > 3) {
                return { width: '45px', height: '45px' };
            } else {
                return { width: '60px', height: '60px' };
            }
        }
    },
    created() {
        const data = this.$route.query;
        if (data.id) {
            if (data.id.includes("app")) {
                const id = data.id;
                this.userId = id.substring(3);
            }
        }
    },
    mounted() {
        // setTimeout(() => {
        // 966da4ac050e4dc0b8d1f2ed892cfac4_h5
        // 18976df0eb9d4b649a902ae5e43fc398
        const token = Cookies.get("token");
        const secretKey = Cookies.get("secretKey");
        if (token && (token.includes('app') || token.includes('h5'))) {
            // 有效token的处理
            Cookies.set("mini-token", token);
            Cookies.set("mini-secretKey", secretKey);
            this.list();
            this.queryTodaySignInDayList();
        } else {
            const data = this.$route.query;
            if (data.token && data.secretKey) {
                Cookies.set("mini-token", data.token);
                Cookies.set("mini-secretKey", data.secretKey);
                this.list();
                this.queryTodaySignInDayList();
            }
        }
        // }, 200)
    },
    methods: {
        handleBlankClick() {
            // backHome.postMessage("");
             if (window.flutter_inappwebview && window.flutter_inappwebview.callHandler) {
                window.flutter_inappwebview
                    .callHandler("backHome")
                    .then((result) => {
                        console.log("Flutter返回:", result);
                    })
                    .catch((err) => {
                        console.error("调用失败:", err);
                        const url = `backHome`;
                        backHome.postMessage(`${url}`);
                    });
            } else {
                const url = `backHome`;
                backHome.postMessage(`${url}`);
            }
        },
        list() {
            const params = {
                current: 1,
                size: 99
            }
            signInlist(params).then((res) => {
                this.loading = false;
                let data = res.records;
                const result = [];
                // 按天数排序，确保数据有序
                data.sort((a, b) => a.days - b.days);
                const maxDay = Math.max(...data.map(item => item.days));
                // 检查连续性并构建结果数组
                for (let i = 1; i <= maxDay; i++) {
                    const item = data.find(d => d.days === i);
                    if (item) {
                        // 如果找到对应天数的签到记录，推入完整的对象
                        result.push(item);
                    } else {
                        // 如果没找到，说明不连续，推入一个表示缺失天数的对象
                        result.push({ days: i, type: 0 });
                    }
                }
                this.allData = result;
                this.listDataTotla = res.total;
                this.updateListData();
            })
            // .catch(() => {
            //     Notify({
            //         type: 'danger',
            //         message: '请返回重试',
            //         duration: 1000
            //     })
            //     backHome.postMessage("");
            // })
        },
        updateListData() {
            // 计算应该显示第几组（每组7天）
            const groupIndex = Math.floor((this.todaySignInDay) / 7);
            const startIndex = groupIndex * 7;
            this.listData = this.allData.slice(startIndex, startIndex + 7);
        },
        queryTodaySignInDayList() {
            queryTodaySignInDay().then((res) => {
                this.loading = false;
                this.todaySignInDay = res.todaySignInStatus;
                this.totalSignInDays = res.totalSignInDays;
                this.continuousSignInDays = res.continuousSignInDays;
            })
        },
        // 点击以后再说
        closePageCompletely() {
            // backHome.postMessage("");
            if (window.flutter_inappwebview && window.flutter_inappwebview.callHandler) {
                window.flutter_inappwebview
                    .callHandler("backHome")
                    .then((result) => {
                        console.log("Flutter返回:", result);
                    })
                    .catch((err) => {
                        console.error("调用失败:", err);
                        const url = `backHome`;
                        backHome.postMessage(`${url}`);
                    });
            } else {
                const url = `backHome`;
                backHome.postMessage(`${url}`);
            }
            // this.show = false;
            this.$forceUpdate(); // 强制更新视图
        },
        goRecord() {
            // this.$router.push({
            //     path: "/collectionRecord",
            //     query: {
            //         id: this.userId
            //     }
            // });
            const url = `collectionRecord?id=${this.userId}`;
            // openWebPage.postMessage(`${url}`);
             if (window.flutter_inappwebview && window.flutter_inappwebview.callHandler) {
                    window.flutter_inappwebview
                        .callHandler("openWebPage", {url: `${url}`})
                        .then((result) => {
                            console.log("Flutter返回:", result);
                        })
                        .catch((err) => {
                            console.error("调用失败:", err);
                            openWebPage.postMessage(`${url}`);
                        });
                } else {
                    openWebPage.postMessage(`${url}`);
                }
        },
        collect() {
            // const currentSignInItem = this.listData.find(item => item.days === this.todaySignInDay + 1);
            // 获取当前签到的type类型
            // const currentSignInType = currentSignInItem ? currentSignInItem.type : null;
            const nextSignInDay = this.todaySignInDay + 1;
            if (nextSignInDay === 7 || nextSignInDay === 14 || nextSignInDay === 28) {
                // 显示分享弹框
                this.showGift = true;
            } else {
                this.executeSignIn();
            }
        },
        // 新增方法：执行签到接口
        executeSignIn() {
            querySignIn().then((res) => {
                this.obtain = res;
                this.showContent = true;
                this.show = false;
                Toast({
                    message: '签到成功',
                    position: "center",
                    duration: 3000
                });
                this.list();
            })
        },
        submitCLose() {
            this.showContent = false;
            Notify({
                type: 'success',
                message: '领取成功',
                duration: 1000
            });
            // backHome.postMessage("");
            if (window.flutter_inappwebview && window.flutter_inappwebview.callHandler) {
                window.flutter_inappwebview
                    .callHandler("backHome")
                    .then((result) => {
                        console.log("Flutter返回:", result);
                    })
                    .catch((err) => {
                        console.error("调用失败:", err);
                        const url = `backHome`;
                        backHome.postMessage(`${url}`);
                    });
            } else {
                const url = `backHome`;
                backHome.postMessage(`${url}`);
            }
        },
        // 礼包签到弹窗
        submit() {
            this.showGift = true;
        },
        giftSubmit() {
            this.showShare = true;
        },
        shareSubmit() {
            // 大转盘分享模板
            // 无门槛免费抽奖，奖品超多，加入我们开始你的幸运之旅吧！
            // https://apph5web.wowotown.com/turntable?id=1920683767201054721&invitationCode=8uprncxdg4xj7&registerActivityId=1930138870706388994
            // end
            const title = "每天签到居然有大礼包！";
            const description = "我刚在窝窝投领到了，快来一起薅福利！";
            const url = `checkBox?id=${this.$route.query.id.substring(
                3
            )}`;
            // jsBridgeForShare.postMessage(`${title}|${description}|${url}`);
            if (window.flutter_inappwebview && window.flutter_inappwebview.callHandler) {
                window.flutter_inappwebview
                    .callHandler("jsBridgeForShare", {info: `${title}|${description}|${url}`})
                    .then((result) => {
                        console.log("Flutter返回:", result);
                    })
                    .catch((err) => {
                        console.error("调用失败:", err);
                        jsBridgeForShare.postMessage(`${title}|${description}|${url}`);
                    });
            } else {
                jsBridgeForShare.postMessage(`${title}|${description}|${url}`);
            }
            // end
            this.showGift = false;
            this.executeSignIn();
        },
    },
};
</script>
<style lang="less" scoped>
.popup {
    display: flex;
    flex-direction: column;
    justify-content: center;
    text-align: center;
}

.title {
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: 14px;
    margin: 5px 5px;
}

.sign {
    font-weight: 500;
    font-size: 14px;
    color: #8C3F0A;
}

.signRecord {
    font-weight: 400;
    font-size: 14px;
    color: #FF722B;
    border-bottom: 1px solid #FF722B
}

.buts {
    background: #FF722B;
    border-radius: 9px;
    font-weight: 500;
    font-size: 16px;
    color: #FFFFFF;
    padding: 7px 0;
    width: 85%;
    margin: 10px auto 2px auto;
}

.list {
    display: flex;
    flex-wrap: wrap;
    width: 100%;
    gap: 5px;
    margin-top: 5px;
    // justify-content: space-between;
    margin-bottom: 2%;
}

.itemList {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: center;
    background-color: #FFF6E2;
    border-radius: 8px;
    padding: 3px 5px;
    box-sizing: border-box;
    height: 90px;
    width: calc(25% - 4px);
    flex-shrink: 0;
}

/* 第二行最后一个项目占两个宽度 */
.itemList:nth-child(7) {
    width: calc(50% - 2.5px);
}

.pouponDetail {
    font-weight: 500;
    font-size: 12px;
    color: #951831;
    text-align: center;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    line-height: 1.2;
    width: 100%;
    flex-shrink: 0;
}


.giftName {
    font-size: 12px;
    white-space: nowrap;
    margin-top: 2px;
}

.giftImg {
    width: 32px;
    height: 32px;
    position: relative;
}

.giftImg.blurred {
    filter: blur(3px);
    opacity: 0.6px;
}

.already {
    position: absolute;
    top: -6px;
    right: -6px;
    width: 47px;
    height: 46px;
    z-index: 10;
    /* 确保覆盖图片在最上层 */
    filter: none;
    /* 确保覆盖图片不受模糊效果影响 */
    opacity: 1;
    /* 确保覆盖图片完全不透明 */
}

.popupList {
    display: flex;
    flex-direction: column;
    text-align: center;
    justify-content: center;
    position: absolute;
    width: 72vw;
    left: 0;
    right: 0;
    top: 32%;
    margin: 0 auto;
    height: 27vh;
    overflow: hidden;
    overflow-y: auto;

    .signTitle {
        font-size: 20px;
        /* 移动端兼容的渐变文字方案 */
        background: linear-gradient(to right, #353426 0%, #90243A 100%);
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
        background-clip: text;
        /* 添加fallback颜色，当渐变不支持时使用 */
        color: #353426;
        font-weight: bold;
        margin-bottom: 5px;
    }

    .popImg {
        width: 60px;
        height: 60px;
        border-radius: 10px;
        margin: 0 auto;
        object-fit: cover;
        // object-fit: contain;
    }

    .contentList {
        display: flex;
        flex-wrap: wrap;
        gap: 10px;
        max-width: 100%;
    }

    .centerContent {
        display: flex;
        flex-direction: column;
        align-items: center;
        width: calc(33.33% - 10px);
        max-width: 80px;
        margin: 5px auto;

        span {
            font-size: 12px;
            text-align: center;
            word-wrap: break-word;
            line-height: 1.2;
        }
    }

    // 控制数量超过3个时是否居中展示;
    .contentList:has(.centerContent:nth-child(4)):not(:has(.centerContent:nth-child(6))) .centerContent {
        margin: 5px 0;
    }
}

.explain {
    height: 100px;
    overflow: hidden;
    overflow-y: scroll;
    font-size: 15px;
    width: 90%;
}

.qrName {
    font-size: 18px;
    font-weight: bold;
    margin-bottom: 20px;
}

.addList {
    display: flex;
    align-items: center;
}

.dateList {
    font-size: 14px;
}

.loginBackground {
    background: url(https://wowoto.oss-cn-shanghai.aliyuncs.com/pinboo/sign_in_bg.png) no-repeat;
    background-size: 100% 100%;
    height: 418px;
    width: 340px;
    position: relative;
    left: 8%;
    right: 0;
}

.sign_title {
    position: absolute;
    top: 19%;
    left: 10%;
    font-size: 15px;
}


.signSucc {
    background: url(../assets/signIn/signInSucc.png) no-repeat;
    background-size: 100% 100%;
    height: 370px;
    width: 86vw;
    position: relative;
    overflow: hidden;
}

.signSuccLength {
    background: url(../assets/signIn/signInSuccLength.png) no-repeat;
    background-size: 100% 100%;
    height: 453px;
    width: 86vw;
    position: relative;
    overflow: hidden;
}
</style>
